import { QUESTIONNAIRE_API_HOSTS } from '../utils/env';
import requestJson from './request';

export const postReview = (
  productId: number,
  rating: number,
  reviewText: string,
  fingerprint: string,
  env: 'dev' | 'prod',
) => {
  const host = QUESTIONNAIRE_API_HOSTS[env];
  const endpoint = `/reviews/1/self/product`;
  const requestHeaders = new Headers();
  requestHeaders.set('Accept', '*/*');
  requestHeaders.set('Content-Type', 'application/json');
  return requestJson({
    url: host + endpoint,
    method: 'POST',
    headers: requestHeaders,
    body: {
      productId,
      rating,
      reviewText,
      fingerprint,
    },
  });
};
